/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMoneyInvestment = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M11.537 1.114a1 1 0 0 1 .926 0l9.09 4.75a1 1 0 0 1-.462 1.886H2.909a1 1 0 0 1-.463-1.886zm5.48 4.636L12 3.128 6.982 5.75zm-13.29 12.4V9.6h2v8.55zm3.637 0V9.6h2v8.55zm3.636 0V9.6h2v1.946c-.691.807-1 1.91-1 3.204 0 1.1.373 2.11 1 2.916v.484zM13 20v2H2v-2zm4-9v1h-.25a2.75 2.75 0 1 0 0 5.5H17V19h-2v2h2v1h2v-1h.25a2.75 2.75 0 1 0 0-5.5H19V14h2v-2h-2v-1zm-.25 3H17v1.5h-.25a.75.75 0 0 1 0-1.5zM19 19v-1.5h.25a.75.75 0 0 1 0 1.5z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgMoneyInvestment as MoneyInvestment };
